import { HsVector3 } from '../../math-new/objects/vector3.class';
import { HsForce } from './force.class';

export class HsWindForce extends HsForce {
  public turbulence: number = 1;

  private readonly originalDirection: HsVector3 = HsVector3.makeUnitVectorX();

  constructor(direction: HsVector3, strength: number = 1) {
    super(strength);
    this.direction.copy(direction);
    this.strength = strength;
    this.originalDirection.copy(direction);
  }

  public getDirection(): HsVector3 {
    return this.direction;
  }

  public update(): void {
    this.direction.setRandom().multiplyByScalar(this.turbulence);
    this.direction.setFromLerp(this.direction, this.originalDirection, 0.75);
  }
}
